import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis
} from "recharts";
import { colors } from "./theme";

interface HorizontalBarChartProps {
  data: Array<{
    skill: string;
    count: number;
    color: string;
  }>;
}

export const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data
}) => (
  <ResponsiveContainer width="100%" height={250}>
    <BarChart
      data={data}
      layout="vertical"
      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
    >
      <CartesianGrid strokeDasharray="3 3" stroke={colors.neutral2 + "30"} />
      <XAxis
        type="number"
        tick={{ fill: colors.primary }}
        tickLine={{ stroke: colors.neutral2 }}
      />
      <YAxis
        type="category"
        dataKey="skill"
        tick={{ fill: colors.primary }}
        tickLine={{ stroke: colors.neutral2 }}
        width={150}
      />
      <RechartsTooltip
        contentStyle={{
          backgroundColor: "#fff",
          borderColor: colors.neutral2,
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
        }}
        formatter={(value) => [`${value} drivers`, "Count"]}
      />
      <Bar dataKey="count" radius={[0, 4, 4, 0]}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);